export const DRAWERS = {
  MANAGE_DATA_MODEL_DRAWER: "manageDataModelDrawer",
  MANAGE_COLLECTION_DRAWER: "manageCollectionDrawer",
  MANAGE_ENDPOINT_DRAWER: "manageEndpointDrawer",
  MANAGE_PROPERTY_DRAWER: "managePropertyDrawer",
  MANAGE_RECORD_DRAWER: "manageRecordDrawer",
  CREATE_PROPERTY_DRAWER: "createPropertyDrawer",
  MANAGE_BACKGROUND_TASK_DRAWER: "manageBackgroundTaskDrawer",
  CREATE_INTEGRATION_DRAWER: "createIntegrationDrawer",
  DEPLOYMENT_LOGS_DRAWER: "DeploymentLogsDrawer",
  MANAGE_ORGANIZATION_DRAWER: "manageOrganizationDrawer",
  MANAGE_APP_DRAWER: "manageAppDrawer",
};

export const INTERFACES = {
  INPUT: "input",
  CHECKBOX: "checkbox",
  CHECKBOXES: "Checkboxes",
  DATE_TIME: "datetime",
  FILE: "file",
  SELECT: "select",
  TEXT_AREA: "text-area",
  RADIO: "select-radio",
  INPUT_HASH: "input-hash",
  BOOLEAN: "boolean",
  LIST_O2M: "list-o2m",
  ACE_EDITOR: "aceEditor",
  NUMBER: "number",
  KEY_VALUE_FORM: "keyValueForm",
  TEXT: "TEXT",
  TOGGLE: "toggle",
  REPEATER_FIELDS: "repeater-fields",
  IMAGE: "image",
  INPUT_FORM: "inputForm",
  EMAIL: "email",
  FLOAT_NUMBER: "floatNumber",
  JSON_TYPE: "Json"
};

export const GLOBAL_INFRASTRUCTURE_REGIONS = [
  {
    name: "North America",
    value: "north-america",
  },
  {
    name: "South America",
    value: "south-america",
  },
  {
    name: "Europe",
    value: "europe",
  },
  {
    name: "Middle East",
    value: "middle-east",
  },
  {
    name: "Africa",
    value: "africa",
  },
  {
    name: "Asia Pacific",
    value: "asia-pacific",
  },
  {
    name: "Australia",
    value: "australia",
  },
];

export const SPECIALS = {
  HASH: "hash",
  COLOR: "color",
  CAST_BOOLEAN: "cast-boolean",
  ONE_TO_MANY: "o2m",
  CAST_JSON: "cast-json",
};

export const DRAWER_SIZE = {
  MD: "medium",
  FULL: "fullScreen",
};

export const OPERATIONS = {
  CREATE: "create",
  DELETE: "delete",
  UPDATE: "update",
};

export const BACKGROUND_TASKS_FIELDS = {
  INPUTS: "inputs",
  END_DATE: "endDate",
  CUSTOM_FUNCTIONS: "customFunction",
  STATEMENT: "statement",
  BODY: "body",
  PARAMS: "params",
  HEADERS: "headers",
  COLLECTION: "collection",
};

export const DATA_SOURCE = "datasource";
export const CUSTOM = "custom";
export const DROPDOWN_TYPE = [
  { name: "Custom", value: "custom" },
  { name: "DataSource", value: "datasource" },
];
